import { EntityState } from '@/api/resources/entityState/entity-state'
import { EntityStatusState, StoreStateModel } from '@/store/root/root-store.model'
import { store } from '@/store/store'
import { commonStatusService } from '@/api/services/common/status/common-status.service'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { SubportionAnalysisStatusResponse } from '@/api/services/common/status/common-status.dto'

class AiAnalysisState extends EntityState {
    protected get entityName(): string {
        return 'ai-analysis'
    }

    async loadStates(): Promise<void> {
        if (!this.states.length) {
            const response = await PromiseUtils.toCallSecure(commonStatusService.getAiAnalysisStates())
            const states: SubportionAnalysisStatusResponse[] = response ?? []
            const entityState: StoreStateModel<EntityStatusState[]> = {
                name: this.entityName,
                state: Object.values(states)
            }
            await store.dispatch('setEntityState', entityState)
        }
    }
}

export const aiAnalysisState = new AiAnalysisState()
